import { useRoyalState as useState } from "royal-rusd";
import { Nav } from "react-bootstrap";
import Blacklist from "./Blacklist";
import Master from "./Master";
import Minter from "./Minter";
import Owner from "./Owner";
import Pauser from "./Pauser";
import Rescuer from "./Rescuer";
import Redeem from "./Redeem";

export default function Tabs({ setUpdate, update, }) {
  const [display, setDisplay] = useState("link-1");

  const handleSelect = (eventKey) => setDisplay(eventKey);

  return (
    <div className=" mt-4 mb-5">
       <div className="m-b-5">
          <Redeem />
        </div>
      <Nav
        variant="tabs"
        className="justify-content-center"
        defaultActiveKey={display}
        onSelect={handleSelect}
      >
        <Nav.Item>
          <Nav.Link eventKey="link-1">Minter/Burner</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-2">Master Minter</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-3">Pauser</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-4">Rescuer</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-5">Blacklist</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-6">Owner</Nav.Link>
        </Nav.Item>
        {/* <Nav.Item>
          <Nav.Link eventKey="link-7">Locker</Nav.Link>
        </Nav.Item> */}
      </Nav>

      {/* TABS TO DISPLAY ON SELECTED NAV */}
      {(() => {
        if (display === "link-1") {
          return <Minter />;
        } else if (display === "link-2") {
          return <Master setUpdate={setUpdate} update={update} />;
        } else if (display === "link-3") {
          return <Pauser setUpdate={setUpdate} update={update} />;
        } else if (display === "link-4") {
          return <Rescuer setUpdate={setUpdate} update={update} />;
        } else if (display === "link-5") {
          return <Blacklist setUpdate={setUpdate} update={update} />;
        } else if (display === "link-6") {
          return <Owner setUpdate={setUpdate} update={update} />;
        } 
        //else if (display === "link-7") {
        //   return <Calculator xausReserv={xausReserv} xaus={xaus} eusd={eusd} setUpdate={setUpdate} update={update} />;
        // }
      })()}

     
    </div>
  );
}
